import { Box, Grid, Typography } from "@material-ui/core";
import { useGetVotacoesDetalhado } from "data/api/gestao/clickup/get-votacoes-detalhado";
import { VotacoesVotoDetalhadoModel } from "model/api/gestao/votacao-desenvolvimento/votacoes-voto-detalhado";
import { useCallback, useEffect, useState } from "react";
import { ListaRevendasVotoProps } from "./lista-revendas-voto-props";
import { useToastSaurus } from "services/app";
import { useStyles } from "./lista-revendas-voto-styles";
import { CardVotoRevenda } from "views/components/cards/card-voto-revenda";
import { CircularLoading } from "views/components/utils";

export const ListaRevendasVoto = ({ votacaoId }: ListaRevendasVotoProps) => {

    const classes = useStyles()
    const { showToast } = useToastSaurus()
    const [isCarregando, setIsCarregando] = useState<boolean>(false);

    const [listaRevendas, setListaRevendas] = useState<VotacoesVotoDetalhadoModel[]>([]);
    const { getVotacoesDetalhado } = useGetVotacoesDetalhado()

    const handleGetVotacoesDetalhado = useCallback(async () => {
        setIsCarregando(true);
        try {
            const res = await getVotacoesDetalhado(votacaoId);
            if (res.erro) throw res.erro

            const response = res.resultado?.data as VotacoesVotoDetalhadoModel[] | null;
            const removerRevendasRepetidas = response?.reduce((acc: VotacoesVotoDetalhadoModel[], revenda) => {
                if (!acc.some(r => r.usuario === revenda.usuario)) {
                    acc.push(revenda);
                }
                return acc;
            }, []);

            setListaRevendas(removerRevendasRepetidas || []);
        } catch (err: any) {
            showToast('error', 'Erro ao obter os votos da tarefa. Detalhe: ' + err.message);
        } finally {
            setIsCarregando(false);
        }
    }, [getVotacoesDetalhado, setIsCarregando, showToast, votacaoId])

    useEffect(() => {
        handleGetVotacoesDetalhado()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleCardClick = (id: string) => {
        // window.open(`${window.location.origin}/revendedor/${id}`, '_blank');
    }

    return (
        <Grid item xs={12} md={4} className={classes.listaRevendasContainer}>
            {isCarregando && <CircularLoading tipo="FULLSIZED" />}
            <Typography variant='h6' className={classes.listaRevendas} gutterBottom>
                Histórico de votos
            </Typography>

            {listaRevendas.length === 0 ? (
                <Box p={2} textAlign="center" bgcolor="rgba(0,0,0,0.02)" borderRadius={8}>
                    <Typography variant="body2" color="textSecondary">
                        Nenhum voto registrado
                    </Typography>
                </Box>
            ) : (
                <Box maxHeight={300} overflow="auto" p={1}>
                    {listaRevendas
                        .reduce<VotacoesVotoDetalhadoModel[]>((acc, revenda) => {
                            if (acc.some(r => r.usuario === revenda.usuario)) {
                                return acc;
                            }
                            return [...acc, revenda];
                        }, [])
                        .sort((a, b) => new Date(a.data_voto).getTime() - new Date(b.data_voto).getTime())
                        .map((revenda) => (
                            <CardVotoRevenda
                                key={`revenda-${revenda.usuario}`}
                                model={revenda}
                                onClick={handleCardClick}
                            />
                        ))
                    }
                </Box>
            )}
        </Grid>
    )
}